import React from "react";

const ModalBackground = ({ clicked }) => {
  return <div className="__me" onClick={clicked} data-test="ModalBackground"></div>;
};

export default ModalBackground;
